"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TransitionGroup = _interopRequireDefault(require("react-transition-group/TransitionGroup"));

var _formatProps = _interopRequireDefault(require("../helpers/format-props"));

var _CSSTransitionWrapper = _interopRequireDefault(require("./CSSTransitionWrapper"));

var _Debug = _interopRequireDefault(require("./Debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AnimatorParent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AnimatorParent, _React$Component);

  function AnimatorParent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      debug: false
    };
    return _this;
  }

  var _proto = AnimatorParent.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        dataHook = _this$props.dataHook,
        skipMountTransition = _this$props.skipMountTransition,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        onAnimationEnter = _this$props.onAnimationEnter,
        onAnimationEntering = _this$props.onAnimationEntering,
        onAnimationEntered = _this$props.onAnimationEntered,
        onAnimationExit = _this$props.onAnimationExit,
        onAnimationExiting = _this$props.onAnimationExiting,
        onAnimationExited = _this$props.onAnimationExited;
    var animatorProps = (0, _formatProps["default"])(this.props);
    animatorProps.debug = this.state.debug;
    return /*#__PURE__*/_react["default"].createElement(_TransitionGroup["default"], {
      "data-hook": dataHook,
      className: className
    }, animatorProps.children.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_CSSTransitionWrapper["default"], _extends({
        skipMountTransition: skipMountTransition,
        key: item.key || index,
        index: index
      }, item.props, {
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        animatorProps: animatorProps,
        onAnimationEnter: onAnimationEnter,
        onAnimationEntering: onAnimationEntering,
        onAnimationEntered: onAnimationEntered,
        onAnimationExit: onAnimationExit,
        onAnimationExiting: onAnimationExiting,
        onAnimationExited: onAnimationExited
      }), item);
    }), this.props.debug && /*#__PURE__*/_react["default"].createElement(_Debug["default"], {
      hasChildren: !!animatorProps.children.length,
      onSelect: function onSelect(debug) {
        return _this2.setState({
          debug: debug
        });
      }
    }));
  };

  return AnimatorParent;
}(_react["default"].Component);

AnimatorParent.defaultProps = {
  skipMountTransition: false,
  mountOnEnter: true,
  unmountOnExit: true
};
var _default = AnimatorParent;
exports["default"] = _default;